export type VisiblePagesType = {
  small: {
    left: number;
    right: number;
  };
  large: {
    left: number;
    right: number;
  };
};

export const visiblePages = (
  currentPage: number,
  pageCount: number
): VisiblePagesType => ({
  small: {
    left:
      currentPage - 2 > 0
        ? currentPage - (currentPage === pageCount ? 3 : 2)
        : 0,
    right: currentPage + (currentPage === 1 ? 3 : 2),
  },
  large: {
    left:
      currentPage - 3 > 0
        ? currentPage -
          (currentPage === pageCount
            ? 5
            : currentPage === pageCount - 1
            ? 4
            : 3)
        : 0,
    right: currentPage + (currentPage === 1 ? 5 : currentPage === 2 ? 4 : 3),
  },
});
